<template>
  <v-content>
    <v-container fluid>
      <v-layout row justify-center>
        <v-flex xs12 sm8 lg6>
          <v-card class="mt-3 pa-3" color="grey lighten-3">
            <v-card-title primary-title>
              <div class="headline">Reestablece tu contraseña</div>
            </v-card-title>
            <v-card-text>
              <v-layout row justify-center>
                <v-flex xs10>
                  <v-form v-model="valid" ref="form">
                    <v-subheader>Introduce tu nueva contraseña.</v-subheader>
                    <v-layout row justify-center>
                      <v-flex xs11>
                        <v-text-field
                          label="Contraseña nueva"
                          :counter="24"
                          v-model="password"
                          :rules="passwordRules"
                          type="password"
                          required
                        ></v-text-field>
                        <v-text-field
                          label="Confirmar contraseña nueva"
                          :counter="24"
                          v-model="confirmPassword"
                          :rules="confirmPasswordRules"
                          type="password"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text>
              <v-alert color="error" icon="error" v-model="errorAlert">{{ errorAlertMessage }}</v-alert>
              <v-alert color="success" icon="check" v-model="successAlert">{{ successAlertMessage }}</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="$refs.form.reset()">limpiar</v-btn>
              <v-btn
                flat
                color="success"
                @click="submit"
                :loading="loading"
              >reestablecer</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { resetPassword } from '@/api/auth'

export default {
  name: 'reset-password',
  data: function () {
    return {
      errorAlert: false,
      errorAlertMessage: '',
      successAlert: false,
      successAlertMessage: '',
      valid: false,
      loading: false,
      password: '',
      confirmPassword: '',
      passwordRules: [
        (value) => !!value || 'Campo requerido',
        (value) => (value && value.length <= 24) || 'La contraseña debe contener menos de 24 caracteres',
        (value) => /^[a-zA-Z0-9_.-]+$/.test(value) || 'Contraseña inválida'
      ],
      confirmPasswordRules: [
        (value) => value === this.password || 'Las contraseñas no coinciden'
      ]
    }
  },
  methods: {
    submit: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          await resetPassword({
            password: this.password,
            token: this.$route.params.token
          })
        } catch (e) {
          this.$refs.form.reset()
          this.loading = false
          const message = e.message || 'Ooops, ha ocurrido un error'
          this.errorAlertMessage = message
          this.errorAlert = true
          return false
        }
        this.$refs.form.reset()
        this.loading = false
        this.errorAlert = false
        this.successAlertMessage = 'Enhorabuena, tu contraseña ha sido reestablecida con éxito'
        this.successAlert = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue